export enum FolderType {
	Insight,
	View,
	Schedule
}

export interface Folder {
	id: string
	title: string
	folderType: FolderType
	teams: string[]
	expanded?: boolean
	parentFolderId?: string
	pathToRoot?: string
}

export interface FolderItem {
	id: string,
	title: string,
	folder: string,
	itemCount?: number
}

export interface FolderItems {
	id?: string,
	folderTitle: string,
	expanded: boolean,
	isFolderType: true,
	[key:string]: any,
	allowRowClick: true,
	onlyEmitOnRowClick: true,
	subFolders?: FolderItems[],
	parentFolderId?: string
}
